import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useAuth, useSignIn, useSignUp } from "@clerk/clerk-react";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { CallWithOutAuth } from '../../../actions/apiAction';
import { GET_PUBLIC_PROFILE_URL } from '../../../utils/apiUrl';
import { startGoogleOAuth } from '../../../utils/clerkOAuth';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import toast from 'react-hot-toast';
import { Avatar } from '@mui/material';
import facebookImage from '../../../assets/images/facebook.svg';
import appleImage from '../../../assets/images/apple.svg';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ChatLanding = () => {
    const { username } = useParams();
    const { signIn, isLoaded, setActive } = useSignIn();
    const { signUp, setActive: setActiveSignUp } = useSignUp();
    const navigate = useNavigate();
    const { isSignedIn } = useAuth();
    const [userDetails, setUserDetails] = useState(null)
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [month, setMonth] = useState("");
    const [day, setDay] = useState("");
    const [year, setYear] = useState("");
    const [error, setError] = useState("");
    const [isRegister, setIsRegister] = useState(true)
    const [dob, setDob] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [togglePassword, setTogglePassword] = useState(false)
    const [showOtp, setShowOtp] = useState(false);
    const [otp, setOtp] = useState("");

    useEffect(() => {
        if (isLoaded) {
            getUserDetails();

        }
    }, [isLoaded]);
    const is18Plus = () => {
        if (!dob) return false;

        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age >= 18;
    };
    const getUserDetails = async () => {
        const responce = await CallWithOutAuth("GET", GET_PUBLIC_PROFILE_URL(username));
        if (responce.status == 200) {
            console.log('responce?.data', responce?.data)
            if (responce?.data) {
                setUserDetails(responce?.data)
                isSignedIn && navigate(`/user/creator-list?username=${username}`);
            } else {
                if (isSignedIn) {
                    navigate('/creator-not-found/' + username)
                } else {
                    navigate('/login')
                }
            }
        } else {
            // toast.error(responce?.data?.detail)
            if (isSignedIn) {
                navigate('/creator-not-found/' + username)
            } else {
                navigate('/login')
            }
        }

    }
    const handleRegister = async () => {
        setError("");

        if (!is18Plus()) {
            setError("You must be 18+ to continue.");
            return;
        }

        if (!isLoaded) return;

        try {
            await signUp.create({
                emailAddress: email,
                password,
                firstName,
                lastName,
            });

            await signUp.prepareEmailAddressVerification({
                strategy: "email_code",
            });

            navigate("/otp-verification"); // or show OTP screen
        } catch (err) {
            setError(err.errors?.[0]?.message || "Registration failed");
        }
    };

    const handleLogin = async () => {
        setError("");
        if (!isLoaded) return;

        try {
            const result = await signIn.create({
                identifier: email,
                password,
            });

            if (result.status === "complete") {
                await setActive({ session: result.createdSessionId });
                // navigate(`/user/creator-list?username=${username}`);
                window.location.href = `/user/creator-list?username=${username}`
            } else if (result.status === "needs_second_factor") {

                await signIn.prepareSecondFactor({ strategy: "email_code" });
                setShowOtp(true);
            }
        } catch (err) {
            setError(err.errors?.[0]?.message || "Login failed");
        }
    };

    const handleVerifyOtp = async () => {
        setError("");
        try {
            const result = await signIn.attemptSecondFactor({
                strategy: "email_code",
                code: otp,
            });

            if (result.status === "complete") {
                await setActive({ session: result.createdSessionId });
                navigate(`/user/creator-list?username=${username}`);
            } else {
                setError("Verification failed. Please try again.");
            }
        } catch (err) {
            setError(err.errors?.[0]?.message || "OTP verification failed");
        }
    };
    const handleGoogleLogin = async () => {
        if (!isLoaded) return;
        sessionStorage.setItem("redirectUsername", username);
        try {

            await startGoogleOAuth({
                signIn,
                signUp,
                redirectUrlComplete: `/user/creator-list?username=${username}`,
            });
        } catch (err) {
            setError(err.errors?.[0]?.message || 'Google login failed');
        }
    };

    const handleFacebookLogin = async () => {
        if (!isLoaded) return;
        sessionStorage.setItem("redirectUsername", username);
        try {
            await signIn.authenticateWithRedirect({
                strategy: "oauth_facebook",
                redirectUrl: "/sso-callback",
                redirectUrlComplete: `/user/creator-list?username=${username}`,
            });
        } catch (err) {
            await signUp.authenticateWithRedirect({
                strategy: "oauth_facebook",
                redirectUrl: "/sso-callback",
                redirectUrlComplete: `/user/creator-list?username=${username}`,
            });
        }
    };

    const handleAppleLogin = async () => {
        if (!isLoaded) return;
        sessionStorage.setItem("redirectUsername", username);
        try {
            await signIn.authenticateWithRedirect({
                strategy: "oauth_apple",
                redirectUrl: "/sso-callback",
                redirectUrlComplete: `/user/creator-list?username=${username}`,
            });
        } catch (err) {
            await signUp.authenticateWithRedirect({
                strategy: "oauth_apple",
                redirectUrl: "/sso-callback",
                redirectUrlComplete: `/user/creator-list?username=${username}`,
            });
        }
    };

    // useEffect(() => {
    //     getUserDetails()
    // }, [])

    if (!isLoaded || isSignedIn) {
        return (
            <div className="min-h-screen gradient-bg-1 flex flex-col items-center justify-center p-6">
                <div className="flex justify-center items-center py-20 flex-auto">
                    <div className="loaderBox" style={{ position: 'unset', margin: 0, padding: 0, height: 'unset', width: 'unset' }}>
                        <div className="relative flex items-center justify-center">
                            <div className="absolute w-16 h-16 rounded-full bg-[#AF0056]/20 blur-xl animate-pulse"></div>
                            <div className="w-10 h-10 rounded-full border-4 border-transparent border-t-[#AF0056] border-r-pink-400 animate-spin"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <>
            <Helmet>
                <title>Chat Onboarding</title>
            </Helmet>

            <div className="min-h-screen gradient-bg-1 flex flex-col items-center justify-center p-6">
                <div
                    className="max-w-sm w-full text-center"
                    style={{ opacity: 1, transform: "none" }}
                >
                    <div className="mb-6" style={{ transform: "none" }}>
                        {/* <img
                            src={userDetails?.profile_picture_url}
                            alt="Reya Sunshine"
                            className="w-28 h-28 rounded-full mx-auto mb-4 shadow-2xl border-4 border-card"
                        /> */}
                        <Avatar
                            style={{ height: '100px', width: '100px' }}
                            alt="Remy Sharp" className="w-28 h-28 rounded-full mx-auto mb-4 shadow-2xl border-4 border-card" src={userDetails?.profile_picture_url}>{userDetails?.first_name?.charAt(0)}</Avatar>
                        <h1 className="text-3xl font-bold text-foreground mb-2">{userDetails?.first_name} {userDetails?.last_name}</h1>
                        <p className="text-lg text-foreground/80 font-light">
                            {userDetails?.description}
                        </p>
                    </div>
                    <div
                        className="bg-card rounded-3xl shadow-xl p-6 signintoSyntimacy-innner-update box-border"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        {isRegister ? <p className="text-foreground/70 mb-4 text-sm">
                            Enter your date of birth to continue. You must be 18+.
                        </p> :
                            <p className="text-foreground/70 mb-4 text-sm">
                                Sign in to continue chatting with {userDetails?.first_name}.
                            </p>}
                        {/* <div className="grid grid-cols-3 gap-2 mb-4">

                            <select
                                className="flex h-10 w-full items-center justify-between rounded-md border border-input px-3 py-2 text-sm bg-background"
                                value={month}
                                onChange={(e) => setMonth(e.target.value)}
                            >
                                <option value="">Month</option>
                                {[...Array(12)].map((_, i) => (
                                    <option key={i} value={i + 1}>{i + 1}</option>
                                ))}
                            </select>
                            <select
                                className="flex h-10 w-full items-center justify-between rounded-md border border-input px-3 py-2 text-sm bg-background"
                                value={day}
                                onChange={(e) => setDay(e.target.value)}
                            >
                                <option value="">Day</option>
                                {[...Array(31)].map((_, i) => (
                                    <option key={i} value={i + 1}>{i + 1}</option>
                                ))}
                            </select>

                            <select
                                className="flex h-10 w-full items-center justify-between rounded-md border border-input px-3 py-2 text-sm bg-background"
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                            >
                                <option value="">Year</option>
                                {Array.from({ length: 100 }, (_, i) => (
                                    <option key={i}>
                                        {new Date().getFullYear() - i}
                                    </option>
                                ))}
                            </select>

                        </div> */}


                        {isRegister && (
                            <>
                                {/* <div className='mb-3 w-full'>
                                    <input
                                        type="date"
                                        className="w-full min-w-0 border border-input rounded-md px-3 py-2 text-sm bg-white h-[37.6px]"
                                        value={dob}
                                        onChange={(e) => setDob(e.target.value)}
                                    />
                                </div> */}
                                <div className='mb-3 w-full datePicker-div'>
                                    <DatePicker
                                        selected={dob}
                                        onChange={(date) => setDob(date)}
                                        placeholderText="Date of Birth"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        maxDate={new Date()}
                                        className="w-full min-w-0 border border-input rounded-md px-3 py-2 text-sm bg-white appearance-none h-[37.6px]"
                                    />
                                </div>

                                <div className='mb-3 w-full'>
                                    <input
                                        type="text"
                                        placeholder="First Name"
                                        className="w-full border border-input rounded-md px-3 py-2 text-sm bg-white box-border"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                </div>
                                <div className='mb-3 w-full'>
                                    <input
                                        type="text"
                                        placeholder="Last Name"
                                        className="w-full border border-input rounded-md px-3 py-2 text-sm bg-white box-border"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </div>
                            </>
                        )}

                        <div className='mb-3 w-full'>
                            <input
                                type="email"
                                placeholder="Email address"
                                className="w-full border border-input rounded-md px-3 py-2 text-sm bg-white box-border"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="input-with-icon mb-3 w-full">
                            <input
                                type={!togglePassword ? "password" : "text"}
                                placeholder="Password"
                                className="w-full border border-input rounded-md px-3 py-2 text-sm bg-white box-border"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button type='button' onClick={() => setTogglePassword(!togglePassword)}
                                className="icon-btn right-icon">
                                {togglePassword ?
                                    <VisibilityOutlinedIcon />
                                    :
                                    <VisibilityOffOutlinedIcon />}
                            </button>
                        </div>
                        {error && (
                            <p className="text-red-500 text-sm mt-2">{error}</p>
                        )}
                        {/* OTP input — shown only after password verified */}
                        {showOtp && (
                            <div className='mb-3 w-full'>
                                <input
                                    type="text"
                                    placeholder="Enter OTP sent to your email"
                                    className="w-full border border-input rounded-md px-3 py-2 text-sm bg-white box-border"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                />
                            </div>
                        )}
                        <button
                            className="inline-flex items-center justify-center gap-2 them-primary-btn whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full"
                            disabled=""
                            onClick={
                                isRegister
                                    ? handleRegister
                                    : showOtp
                                        ? handleVerifyOtp
                                        : handleLogin
                            }
                        >
                            {showOtp ? "Verify OTP" : `Chat with ${userDetails?.first_name}`}
                        </button>
                        <div class="py-3 flex items-center text-xs text-gray-400 uppercase before:flex-1 before:border-t
                         before:border-gray-300 before:me-6 after:flex-1 after:border-t after:border-gray-300 after:ms-6 
                         dark:text-neutral-500 dark:before:border-neutral-600 dark:after:border-neutral-600">Or</div>
                        <div className="flex justify-center gap-4">
                            <button
                                onClick={handleGoogleLogin}
                                className="w-[40px] h-[40px] flex items-center 
                            justify-center gap-3 border border-gray-300 rounded-full py-3 text-sm font-medium hover:bg-gray-50 transition"
                            >
                                <img
                                    src="/images/google.svg"
                                    alt="Google"
                                    className="w-5 h-5"
                                />
                            </button>
                            <button
                                onClick={handleAppleLogin}
                                className="w-[40px] h-[40px] flex items-center 
                            justify-center gap-3 border border-gray-300 rounded-full py-3 text-sm font-medium hover:bg-gray-50 transition"
                            >
                                <img
                                    src={appleImage}
                                    alt="Apple"
                                    className="w-5 h-5"
                                />
                            </button>
                            <button
                                onClick={handleFacebookLogin}
                                className="w-[40px] h-[40px] flex items-center 
                            justify-center gap-3 border border-gray-300 rounded-full py-3 text-sm font-medium hover:bg-gray-50 transition"
                            >
                                <img
                                    src={facebookImage}
                                    alt="Facebook"
                                    className="w-5 h-5"
                                />
                            </button>
                        </div>
                    </div>
                    <span className="more-text-msg">
                        {isRegister ? (
                            <>
                                Already have an account?{" "}
                                <button
                                    onClick={() => setIsRegister(false)}
                                    className="text-btn"
                                >
                                    Sign In
                                </button>
                            </>
                        ) : (
                            <>
                                Don't have an account?{" "}
                                <button
                                    onClick={() => setIsRegister(true)}
                                    className="text-btn"
                                >
                                    Register
                                </button>
                            </>
                        )}
                    </span>

                </div>

            </div>
        </>
    );
}

export default ChatLanding;
